import { Link } from "react-router-dom";

const CardDefault = ({ title, description, image, link }) => {
  return (
    <div className="max-w-sm rounded overflow-hidden shadow-lg transition duration-300">
      <Link to={link} className="link">
        <img className="w-full" src={image} alt="Connection"></img>
      </Link>
      <div className="px-6 py-3">
        <div className="font-bold text-x3 mb-2 text-green-800">{title}</div>
        <p className="text-gray-900 text-sm">{description}</p>
      </div>
    </div>
  );
};

export default CardDefault;
